import FakeFeatureFlags from "@/mixins/FakeFeatureFlags";
import SoundLibrary from "@/mixins/SoundLibrary";

class SoundPlayer
{
    static musicPlayer = new Audio(null);
    
    static playSound(soundId)
    {
        if (FakeFeatureFlags.features.SOUNDS)
        {
            let audio = new Audio(SoundLibrary.getSound(soundId));
            //console.log("[2026] playing sound " + soundId);
            audio.play();
        }
    }

    static playMusic(soundId)
    {
        if (FakeFeatureFlags.features.SOUNDS)
        {
            this.musicPlayer.pause();
            //console.log("[2026] playing music " + soundId);
            this.musicPlayer = new Audio(SoundLibrary.getSound(soundId));
            this.musicPlayer.play();
        }
    }

    static stopMusic()
    {
        if (FakeFeatureFlags.features.SOUNDS)
        {
            this.musicPlayer.pause();
        }
    }
}

export default SoundPlayer;